"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toast = exports.ToastTypes = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const app_icon_1 = require("../icons/app_icon");
const card_1 = require("../card/card");
const index_1 = require("../buttons/index");
const styled_1 = __importDefault(require("../../styles/styled"));
const theme_1 = __importDefault(require("../../styles/theme"));
var ToastTypes;
(function (ToastTypes) {
    ToastTypes["SUCCESS"] = "success";
    ToastTypes["INFO"] = "info";
    ToastTypes["ERROR"] = "error";
    ToastTypes["WARNING"] = "warning";
    ToastTypes["CAUTION"] = "caution";
})(ToastTypes = exports.ToastTypes || (exports.ToastTypes = {}));
const Toast = ({ flavor, id, onClose, onPauseToastTimeout, onResumeToastTimeout, children }) => {
    (0, react_1.useEffect)(() => {
        document.addEventListener('keydown', handleTabbing, true);
        return () => {
            document.removeEventListener('keydown', handleTabbing, true);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleTabbing = (e) => {
        if (e.key === 'Tab')
            document.getElementById(id).focus();
        document.removeEventListener('keydown', handleTabbing, true);
    };
    let flavorColorValue;
    let iconName;
    switch (flavor) {
        case ToastTypes.SUCCESS:
            flavorColorValue = theme_1.default.colors.greenShamrock;
            iconName = 'DoneIcon';
            break;
        case ToastTypes.ERROR:
            flavorColorValue = theme_1.default.colors.red50;
            iconName = 'AlertIcon';
            break;
        case ToastTypes.WARNING:
            flavorColorValue = theme_1.default.colors.pumpkin;
            iconName = 'AlertIcon';
            break;
        case ToastTypes.CAUTION:
            flavorColorValue = theme_1.default.colors.yellow;
            iconName = 'AlertIcon';
            break;
        default:
        case ToastTypes.INFO:
            flavorColorValue = theme_1.default.colors.azure;
            iconName = 'InformationIcon';
            break;
    }
    return ((0, jsx_runtime_1.jsxs)(ToastCard, Object.assign({ onMouseEnter: onPauseToastTimeout, onFocus: onPauseToastTimeout, onMouseLeave: onResumeToastTimeout, onBlur: onResumeToastTimeout, role: "alert", "aria-live": "polite", id: id, tabIndex: 0, flavorColorValue: flavorColorValue }, { children: [(0, jsx_runtime_1.jsx)(DecoratorIcon, { color: flavorColorValue, name: iconName }), (0, jsx_runtime_1.jsx)(ContentWrapper, { children: children }), (0, jsx_runtime_1.jsx)(Close, { label: 'Close toast', onClick: onClose })] })));
};
exports.Toast = Toast;
const ToastCard = (0, styled_1.default)(card_1.Card)(({ flavorColorValue }) => {
    return {
        display: 'grid',
        width: 'calc(100vw - 80px)',
        maxWidth: '400px',
        gridTemplateColumns: 'auto 1fr auto',
        borderLeft: `solid 8px ${flavorColorValue}`,
        padding: '0',
        alignItems: 'center',
    };
});
const DecoratorIcon = (0, styled_1.default)(app_icon_1.AppIcon)({
    margin: '16px',
    height: '24px',
});
const ContentWrapper = styled_1.default.div({
    margin: '12px 0',
    wordBreak: 'break-word',
});
const Close = (0, styled_1.default)(index_1.CloseButton)({
    margin: '16px',
    alignSelf: 'start',
});
//# sourceMappingURL=toast.js.map